import { render } from "./GemMechanism08.vue?vue&type=template&id=3f311b79&scoped=true"
const script = {}

import "./GemMechanism08.vue?vue&type=style&index=0&id=3f311b79&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f311b79"]])

export default __exports__